var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outer-wrapper"},[_c('div',{staticClass:"chart-wrapper",style:(_vm.esize),attrs:{"id":_vm.ids}})])
}
var staticRenderFns = []

export { render, staticRenderFns }